// extracted by mini-css-extract-plugin
export default {"root":"_3CD-f","small":"_1YMkl","normal":"LW6uf"};